export const COMMON_LOG_TYPES = {
    TAG: { text: "태그", value: "TAG" },
    SEARCH: { text: "검색", value: "SEARCH" },
}